import { now } from './date'
import { VERSION } from './databus'
import type { MediaEvent } from './agent'

export function minify(event: MediaEvent) {
  return {
    eat: event.emittedAt,
    typ: event.type,
    vti: event.currentTime,
    vwi: event.videoWidth,
    vhe: event.videoHeight,
    pau: event.paused,
    eco: event.errorCode,
    wti: event.watchTime,
    rea: event.reason,
    pid: event.playbackId,
    mid: event.mediaId,
    seq: event.sequenceNumber,
  }
}

function isSuccessStatus(status: number) {
  return status >= 200 && status < 300
}

export function postHttp(
  endpoint: string,
  events: MediaEvent[],
  isBeaconRequest: boolean,
  onError: () => void,
) {
  try {
    const body = JSON.stringify({
      sch: 2,
      sat: now(),
      ver: VERSION,
      evt: events.map((event) => minify(event)),
    })
    if (isBeaconRequest) {
      const blob = new Blob([body], {
        type: 'application/json',
      })
      const isBeaconSent = navigator.sendBeacon(endpoint, blob)
      if (!isBeaconSent) {
        fetch(endpoint, {
          keepalive: true,
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body,
        })
          // As isBeaconRequest should be only true when the page quits, this error callback should be never used
          .then((response) => {
            // A resolved fetch is not necessarily a successful request.
            if (!isSuccessStatus(response.status)) {
              onError()
            }
          })
          .catch((error) => {
            // Network failure: the promise rejects, the try/catch cannot see it.
            onError()
          })
      }
    } else {
      const xhr = new XMLHttpRequest()
      xhr.open('POST', endpoint, true)
      xhr.setRequestHeader('Content-Type', 'application/json')
      // Network failures are reported asynchronously, after send() returned.
      xhr.addEventListener('error', () => {
        onError()
      })
      xhr.addEventListener('timeout', () => {
        onError()
      })
      // A completed request may still carry an error status.
      xhr.addEventListener('load', () => {
        if (!isSuccessStatus(xhr.status)) {
          onError()
        }
      })
      xhr.send(body)
    }
  } catch (error) {
    onError()
  }
}
